import BaseApi from '~/api/base';
class ProjectRelationship extends BaseApi {
    constructor() {
        super('/project-relationships');
    }
}
const ProjectRelationshipApi = new ProjectRelationship();
export default ProjectRelationshipApi;
